// POSOrderComplete - Order confirmation screen shown after successful checkout
import React from "react";
import { Button } from "@/components/ui/button";
import { Receipt, Printer } from "lucide-react";
import { POSHeader } from "./POSShared";

export function POSOrderComplete({ orderComplete, tableNumber, tableName, onPrint, onNewOrder, onBack }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-600 to-emerald-700 flex flex-col">
      <POSHeader
        title={tableNumber ? `Mesa ${tableName || tableNumber}` : "Venda Direta"}
        onBack={onBack}
      />

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
          <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Receipt className="w-10 h-10 text-emerald-600" />
          </div>

          <h2 className="text-2xl font-bold text-gray-800 mb-2">Pedido Confirmado!</h2>
          <p className="text-gray-500 mb-6">#{orderComplete.id?.slice(-6)}</p>

          <div className="bg-gray-50 rounded-xl p-4 mb-6">
            <p className="text-3xl font-bold text-emerald-600">{orderComplete.total.toFixed(2)}€</p>
            {orderComplete.cash_change > 0 && (
              <p className="text-amber-600 mt-2">Troco: {orderComplete.cash_change.toFixed(2)}€</p>
            )}
          </div>

          <div className="space-y-3">
            <Button onClick={onPrint} variant="outline" className="w-full h-12">
              <Printer className="w-5 h-5 mr-2" />
              Imprimir Recibo
            </Button>

            <Button onClick={onNewOrder} className="w-full h-12 bg-emerald-500 hover:bg-emerald-600">
              Novo Pedido
            </Button>

            <Button onClick={onBack} variant="ghost" className="w-full">
              Voltar ao Menu
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
